import styled from 'styled-components';
import { DatePicker } from 'antd';

export default styled(DatePicker)`
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 0.5em;
    font-size: 1.6em;
    margin-bottom: 1dem;
    text-align: center;
`;
